import { render } from "./table-size-changer.vue?vue&type=template&id=1286626a"
import script from "./table-size-changer.vue?vue&type=script&lang=js"
export * from "./table-size-changer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__